export enum License {
	Primobox = "TALENT_BSE"
}



// WEBPACK FOOTER //
// ./src/shared/Enums/Licensing/License.ts